/*  NameUtil.js
*   Get names of fields based on ids
*   Created by MRocha
*   29/ March / 2017
*/

import listService      from 'ListService.js';
import constants        from 'Constants.js';
import util             from 'util/Util.js';

class NamesUtil {

    // PF-4981
    // Seems to overlap ListService.determineFieldName, which also acts like part of TableService.buildSelectList
    // Had to add similar code to all three. Afraid to re-factor into common code at this late date in release cycle.
    determineFieldName(id) {
        let concatIds = [];
        let nameSuffix = '';
        let name = '';
        let obj;
        let objId = id;

        if (objId.includes('$cuc_') ) {
            concatIds = objId.split('$cuc_');
            nameSuffix = ' - Current Row - Caption';
        }
        else if (objId.includes('$alc_') ) {
            concatIds = objId.split('$alc_');
            nameSuffix = ' - All Rows - Caption';
        }
        else if (objId.includes('$cur_') ) {
            concatIds = objId.split('$cur_');
            nameSuffix = ' - Current Row';
        }
        else if (objId.includes('$all_') ) {
            concatIds = objId.split('$all_');
            nameSuffix = ' - All Rows';
        }
        else if (objId.includes('$v')) {
            obj = listService.getObject(listService.cleanId(objId.replace('$v', '')));
            if (obj && obj.model.get('factoryKey') === 'control_file_attachment'){
                nameSuffix = ' - Attachment Name';
            }else{                
                nameSuffix = ' - Value';
            }
            objId = objId.replace('$v','');
        }
        else{
            if (objId.includes('$d')) {
                objId = objId.replace('$d','');
                nameSuffix = ' - Attachment File';
            }else{
                obj = listService.getObject(listService.cleanId(objId));
                if (obj && obj.model.get('factoryKey') === 'control_file_attachment'){
                    nameSuffix = ' - Attachment Id';
                } 
            }
        }

        if (objId.includes('$cur_') || objId.includes('$all_')) { //PF-8939 - Table - Drop-down column losing caption/value postfix
            obj = listService.getObject(listService.cleanId(concatIds[0]));
            if (obj && obj.model.get('gridData') && concatIds.length === 2) {
                _.forEach(obj.model.get('gridData'), function (col) {
                    if (col.get('id') === listService.cleanId(concatIds[1]) && col.get('type') === constants.CONTROL_TYPE_TABLE_DROPDOWN) {
                        nameSuffix += ' - Value';
                        return false;
                    }
                });
            }
        }

        if (concatIds.length > 0) {
            obj = listService.getObject( listService.cleanId(concatIds[0]) );
            if (obj) {
                name = obj.model.get('name');
                // find column info in model (GridData )
                _.forEach(obj.model.get('gridData'), function (col) {
                    if (col.get('id') === listService.cleanId(concatIds[1])) {
                        name += ' - ' + col.get('name');
                    }
                });
                name += nameSuffix;
            }
        } else {
            obj = listService.getObject(listService.cleanId(objId));
            if (obj) {
            // Same condition than listService on determineFieldName function. Probably a refactor needed to avoid mistakes
                if (constants.CONTROL_CAPTION_VALUE_KEYS.contains(obj.model.get('factoryKey')) && (nameSuffix === '')) {
                    nameSuffix = ' - Caption';
                }
                name = obj.model.get('name') + nameSuffix;
            }
        }
        return name;
    }

}

const namesUtil = new NamesUtil();
export default namesUtil;